import React from 'react';

export default function SaleIcon({ color = 'currentColor', fontSize = '16px', isSelected = false }) {
  return (
    <>
      <i className='fas fa-ticket-alt' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
